import Vue from 'vue'
export const event = new Vue()
